import { UserProps } from '../../../constants/Common';
import { FirebaseApi } from '../../../firebase/firebaseApi';
import { useReportsContext } from '../ReportsPageWrapper';
import { SiteLogReportFirebaseCalls } from '../StateManagement/models';
import { SiteLogReport } from './SiteLogReport';

type AvailableFirebaseCalls = Extract<
	keyof FirebaseApi,
	SiteLogReportFirebaseCalls
>;

export const SiteLogReportWrapper = ({
	userDetails,
}: UserProps): JSX.Element => {
	const {
		context: { startDate, endDate, firebaseApi },
		dispatch,
	} = useReportsContext<AvailableFirebaseCalls>();

	return (
		<SiteLogReport
			userDetails={userDetails}
			startDateContext={{
				date: startDate,
				setDate: (value): void => dispatch({ key: 'startDate', value }),
			}}
			endDateContext={{
				date: endDate,
				setDate: (value): void => dispatch({ key: 'endDate', value }),
			}}
			firebaseApi={firebaseApi}
		/>
	);
};
